<div class="haendler-page">
    <div class="list-title-row">
        <h3 class="list-title">Meine Händler / Kontakte ({{ getFilteredHaendler().length || 0 }})</h3>
        <span class="spacer"></span>
        <!--        <button (click)="anlegenHaendler()" color="accent" mat-icon-button>-->
        <!--            <mat-icon>add</mat-icon>-->
        <!--        </button>-->
    </div>

    <div style="margin-bottom: 12px">
        <mat-hint class="hinweis-text">
            <strong>Hinweis:</strong>
            <span>
                Neben Viehhändlern können auch allgemeine Kontakte (z.B. Abnehmer für den Abgang) gespeichert
                werden.</span
            >
        </mat-hint>
    </div>

    <div *ngIf="haendlerFehlt" style="margin-bottom: 12px">
        <mat-hint class="hinweis-text" style="display: flex; align-items: flex-start; justify-content: flex-start">
            <div>
                <span class="dot-warn"></span>
            </div>
            <div style="text-align: justify; margin-left: 6px">
                <span>
                    Es muss mind. ein H&auml;ndler hinterlegt werden, sonst ist keine Abgangsmeldung m&ouml;glich.</span
                >
            </div>
        </mat-hint>
    </div>

    <div class="search-container">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Händler durchsuchen...</mat-label>
            <input matInput [formControl]="searchControl" placeholder="Nach Händler, VVVO, Adresse oder E-Mail suchen..." />
            <span matSuffix class="search-suffix">
                <button *ngIf="searchControl.value" mat-icon-button (click)="searchControl.setValue('')" aria-label="Suche löschen">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-icon class="search-suffix-icon">search</mat-icon>
            </span>
        </mat-form-field>
    </div>

    <div class="mobile-cards" *ngIf="isMobileScreen && getFilteredHaendler().length; else desktopOrEmpty">
        <div class="mobile-card" *ngFor="let h of getFilteredHaendler()">
            <div class="mobile-card__header">
                <div class="mobile-card__title-wrap">
                    <div class="mobile-card__title">
                        {{ h.bezeichnung || '-' }}
                        <span class="default-haendler" *ngIf="h.betrieb_id == benutzerprofil.default_haendler_id">(Standard Händler)</span>
                    </div>
                </div>
                <button mat-icon-button class="options-button" matTooltip="E-Mail senden" [disabled]="!h.email" (click)="sendMail(h)">
                    <mat-icon>mail</mat-icon>
                </button>
            </div>
            <div class="mobile-card__grid">
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Händler</span>
                    <span class="mobile-card__value">{{ h.bezeichnung || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">VVVO</span>
                    <span class="mobile-card__value">{{ h.vvvo || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Adresse</span>
                    <span class="mobile-card__value">{{ getAdresse(h) || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">E-Mail</span>
                    <a *ngIf="h.email; else noMobileEmail" class="mobile-card__value" [href]="'mailto:' + h.email">
                        {{ h.email }}
                    </a>
                    <ng-template #noMobileEmail>
                        <span class="mobile-card__value">-</span>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
    <ng-template #desktopOrEmpty>
        <div class="list-wrapper" *ngIf="getFilteredHaendler().length; else noHaendler">
            <div class="list-header">
                <span>Händler</span>
                <span>VVVO</span>
                <span>Adresse</span>
                <span>E-Mail</span>
                <span></span>
            </div>
            <ng-container *ngFor="let h of getFilteredHaendler()">
                <div class="list-row">
                    <span class="row-cell">
                        <span class="mobile-field-label">Händler:</span>
                        <strong>{{ h.bezeichnung }}</strong>
                        <span class="default-haendler" *ngIf="h.betrieb_id == benutzerprofil.default_haendler_id"
                            >(Standard Händler)</span
                        >
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">VVVO:</span>
                        <span class="mobile-field-value">{{ h.vvvo || '-' }}</span>
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">Adresse:</span>
                        <span class="mobile-field-value">{{ getAdresse(h) || '-' }}</span>
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">E-Mail:</span>
                        <a *ngIf="h.email; else noEmail" class="mobile-field-value" [href]="'mailto:' + h.email" (click)="$event.stopPropagation()">
                            {{ h.email }}
                        </a>
                        <ng-template #noEmail>
                            <span class="mobile-field-value">-</span>
                        </ng-template>
                    </span>
                    <span class="row-actions">
                        <button mat-icon-button class="options-button" matTooltip="E-Mail senden" [disabled]="!h.email" (click)="sendMail(h)">
                            <mat-icon>mail</mat-icon>
                        </button>
                    </span>
                </div>
            </ng-container>
        </div>
    </ng-template>

    <ng-template #noHaendler>
        <div class="empty-state">Keine Händler/Kontakte gefunden.</div>
    </ng-template>
</div>
